import * as angular from "angular";
import {NgModule, StaticProvider} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {BzButton, BzSpinner} from "@bringoz/ui";
import {downgradeComponent, downgradeInjectable, downgradeModule, UpgradeModule} from "@angular/upgrade/static";
import {Store, StoreModule} from "@ngrx/store";
import * as agentsEffects from "./modules/agents/angular/state/agents.effects"
import * as accountsEffects from "./modules/account/angular/state/accounts.effects";
import * as ordersEffects from "./modules/oms/angular/state/orders.effects";
import * as routesEffects from "./modules/lean-planning/angular/state/routes.effects";
import * as locationsEffects from "./modules/commons/angular/state/locations/locations.effects";
import * as servicesEffects from "./modules/deliveries/angular/state/services.effects";
import * as tasksEffects from "./modules/tasks/angular/state/tasks.effects";
import * as fulfillmentEffects from "./modules/fulfillment/angular/state/fulfillment/fulfillment.effects";
import * as itineraryEffects from './modules/itineraries/angular/state/itineraries.effects';
import * as visitPlanEffects from './modules/scheduling-project/angular/state/visit-plan-state/visit-plan.effects';
import * as visitPlanJobEffects
  from './modules/scheduling-project/angular/state/visit-plan-job-state/visit-plan-job.effects';
import * as visitScheduleEffects
  from './modules/scheduling-project/angular/state/visit-plan-schedule-state/visit-plan-schedule.effects';
import * as visitPlanAccountEffects
  from './modules/scheduling-project/angular/state/visit-plan-account-state/visit-plan-account.effects';
import * as visitConfigurationEffects
  from './modules/scheduling-project/angular/state/visit-configuration-state/visit-configuration.effects';
import {accountsFeature} from "./modules/account/angular/state/accounts.state";
import {visitPlanFeature} from "./modules/scheduling-project/angular/state/visit-plan-state/visit-plan.state";
import {routesFeature} from "./modules/lean-planning/angular/state/routes.state";
import {EffectsModule} from "@ngrx/effects";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {AuthInterceptor} from "./modules/authentication/angular/services/auth.interceptor";
import {AccountsChanelService} from "./modules/account/angular/services/accounts-chanel.service";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {BootstrapAngularComponent} from "./bootstrap-angular.component";
import {AccountsFacadeService} from "./modules/account/angular/services/accounts-facade.service";
import {FirebaseAppService} from "./modules/persistence-layer/firebase-app.service";
import {LoaderComponent} from "./modules/commons/angular/components/loader/loader.component";
import {commons} from "./modules/commons/angular/state/commons/commons.state";
import {locationsFeature} from "./modules/commons/angular/state/locations/locations.state";
import {LocationsChanelService} from "./modules/commons/angular/services/locations/locations-chanel.service";
import {LocationsFacadeService} from "./modules/commons/angular/services/locations/locations-facade.service";
import {downgradedAgentsModule} from "./modules/agents/angular/agents.module";
import {TimekeepingAngularModule} from "./modules/timekeeping/angular/timekeeping.module";
import {TimekeepingHttpService} from "./modules/timekeeping/angular/services/timekeeping-http.service";
import {TimekeepingViewComponent} from "./modules/timekeeping/angular/components/timekeeping-view/timekeeping-view.component";
import {TimecardDetailComponent} from "./modules/timekeeping/angular/components/timecard-detail/timecard-detail.component";
import {BranchesHttpService} from "./modules/branches/angular/services/branches-http.service";
import {AgentsChanelService} from "./modules/agents/angular/services/agents-chanel.service";
import {AgentsFacadeService} from "./modules/agents/angular/state/agents-facade.service";
import {agentsFeature} from "./modules/agents/angular/state/agents.state";
import {ChatModule} from "./modules/chat/chat.module";
import {ChatViewComponent} from "./modules/chat/components/chat-view/chat-view.component";
import {chatFeature} from "./modules/chat/state/chat.state";
import {ChatFacadeService} from "./modules/chat/state/chat-facade.service";
import {FormsModule} from "@angular/forms";
import {NgbModule, NgbToastModule, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {ChatService} from "./modules/chat/services/chat.service";
import {
  ChatConversationServiceViewComponent
} from "./modules/chat/components/chat-conversation-service-view/chat-conversation-service-view.component";
import {downgradedAccountModule} from "./modules/account/angular/accounts.module";
import {PlanningModule} from "./modules/planning/angular/planning.module";
import {PlanningDragAndDropService} from "./modules/planning/angular/services/planning-drag-and-drop.service";
import {servicesFeature} from "./modules/deliveries/angular/state/services.state";
import {ServicesChanelService} from "./modules/deliveries/angular/services/services-chanel.service";
import {downgradedServicesModule} from "./modules/deliveries/angular/services.module";
import {downgradedResourcesModule} from "./modules/resources/angular/resources.module";
import {ServicesFacadeService} from "./modules/deliveries/angular/services/services-facade.service";
import {AddToRouteComponentStore} from "./modules/deliveries/angular/state/add-to-route.store";
import {tasksFeature} from "./modules/tasks/angular/state/tasks.state";
import {TasksChannelService} from "./modules/tasks/angular/services/tasks-channel.service";
import {TasksFacadeService} from "./modules/tasks/angular/services/tasks-facade.service";
import {BringozButtonComponent} from "./modules/commons/angular/components/bringoz-button/bringoz-button.component";
import {BringozToggleComponent} from "./modules/commons/angular/components/bringoz-toggle/bringoz-toggle.component";
import {BringozSwitchComponent} from "./modules/commons/angular/components/bringoz-switch/bringoz-switch.component";
import {
  BringozCheckboxComponent
} from "./modules/commons/angular/components/bringoz-checkbox/bringoz-checkbox.component";
import {
  BringozDurationMinsHoursInputComponent
} from "./modules/commons/angular/components/bringoz-duration-mins-hours-input/bringoz-duration-mins-hours-input.component";
import {
  DemandAccountTableComponent
} from "./modules/account/angular/components/demand-account-table/demand-account-table.component";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {ChatHttpService} from "./modules/chat/services/chat-http.service";
import {AngularSvgIconModule} from "angular-svg-icon";
import {BringozIconComponent} from "./modules/commons/angular/components/bringoz-icon/bringoz-icon.component";
import {BringozTooltipComponent} from "./modules/commons/angular/components/bringoz-tooltip/bringoz-tooltip.component";
import {BringozSearchInputComponent} from "./modules/commons/angular/components/bringoz-search-input/bringoz-search-input.component";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslationsService} from "./modules/commons/angular/services/translations.service";
import {NgxPermissionsModule, NgxPermissionsService, NgxRolesService} from "ngx-permissions";
import {CommonsModule} from "./modules/commons/angular/commons.module";
import {FulfillmentChannelService} from "./modules/fulfillment/angular/services/fulfillment-channel.service";
import {FulfillmentFacadeService} from "./modules/fulfillment/angular/services/fulfillment-facade.service";
import {fulfillmentFeature} from "./modules/fulfillment/angular/state/fulfillment/fulfillment.state";
import {downgradedAddressesModule} from "./modules/addresses/angular/addresses.module";
import {AddressFacadeService} from "./modules/addresses/angular/state/addresses-facade.service";
import {addressFeature} from "./modules/addresses/angular/state/addresses.state";
import {ServicesTableComponent} from "./modules/deliveries/angular/components/services-table/services-table.component";
import {downgradedTasksModule} from "./modules/tasks/angular/tasks.module";
import {
  ServiceTypeIndicationComponent
} from "./modules/deliveries/angular/components/service-type-indication/service-type-indication.component";
import {
  BringozDonutChartComponent
} from "./modules/commons/angular/components/bringoz-donut-chart/bringoz-donut-chart.component";
import {NgxEchartsModule} from "ngx-echarts";
import * as echarts from 'echarts';
import {downgradedDashboardsModule} from "./modules/dashboards/angular/dashboards.module";
import {DashboardViewComponent} from "./modules/dashboards/angular/components/dashboard-view/dashboard-view.component";
import {CommonsFacadeService} from "./modules/commons/angular/state/commons/commons-facade.service";
import {downgradedPricePlanModule} from "./modules/price-plan/angular/price-plan.module";
import {
  PricePlanBundleStateViewComponent
} from "./modules/price-plan/angular/components/price-plan-bundle-state-view/price-plan-bundle-state-view.component";
import {downgradedGroupsModule} from "./modules/groups/angular/groups.module";
import {GroupsTableComponent} from "./modules/groups/angular/components/groups-table/groups-table.component";
import {GroupsHttpService} from "./modules/groups/angular/services/groups-http.service";
import {
  GroupsColorDisplayListComponent
} from "./modules/groups/angular/components/groups-color-display-list/groups-color-display-list.component";
import {downgradedMapModule} from "./modules/map/angular/map.module";
import {AgentsMapComponent} from "./modules/map/angular/components/agents-map/agents-map.component";
import {AgentLocationComponent} from "./modules/agents/angular/components/agent-location/agent-location.component";
import {
  BringozItemsListDisplayComponent
} from "./modules/commons/angular/components/bringoz-items-list-display/bringoz-items-list-display.component";
import {
  BringozPaginationComponent
} from "./modules/commons/angular/components/bringoz-pagination/bringoz-pagination.component";
import {
  DashboardAgentsTableViewComponent
} from "./modules/dashboards/angular/components/dashboard-agents-table-view/dashboard-agents-table-view.component";
import {
  DashboardServicesTableViewComponent
} from "./modules/dashboards/angular/components/dashboard-services-table-view/dashboard-services-table-view.component";
import {
  PlanningDraftJobsPanelListComponent
} from "./modules/planning/angular/components/planning-draft-jobs-panel-list/planning-draft-jobs-panel-list.component";
import {
  PlanningDraftJobsPanelListItemComponent
} from "./modules/planning/angular/components/planning-draft-jobs-panel-list-item/planning-draft-jobs-panel-list-item.component";
import {
  PlanningDraftJobChangesListComponent
} from "./modules/planning/angular/components/planning-draft-job-changes-list/planning-draft-job-changes-list.component";
import {
  PlanningDraftJobChangesFacadeService
} from "./modules/planning/angular/services/planning-draft-job-changes-facade.service";
import {
  PlanningDraftJobChangesHttpService
} from "./modules/planning/angular/services/planning-draft-job-changes-http.service";
import {
  PlanningDraftRoutesPanelListComponent
} from "./modules/planning/angular/components/planning-draft-routes-panel-list/planning-draft-routes-panel-list.component";
import {
  PlanningDraftRoutesPanelListItemComponent
} from "./modules/planning/angular/components/planning-draft-routes-panel-list-item/planning-draft-routes-panel-list-item.component";
import {
  PlanningDraftRoutePanelViewTestComponent
} from "./modules/planning/angular/components/planning-draft-route-panel-view-test/planning-draft-route-panel-view-test.component";
import {
  PlanningDraftResourcesPanelListComponent
} from "./modules/planning/angular/components/planning-draft-resources-panel-list/planning-draft-resources-panel-list.component";
import {
  PlanningDraftResourcesPanelListItemComponent
} from "./modules/planning/angular/components/planning-draft-resources-panel-list-item/planning-draft-resources-panel-list-item.component";
import {
  PlanningDraftResourcePanelViewComponent
} from "./modules/planning/angular/components/planning-draft-resource-panel-view/planning-draft-resource-panel-view.component";
import {
  PlanningDraftRouteTableDrilldownComponent
} from "./modules/planning/angular/components/planning-draft-route-table-drilldown/planning-draft-route-table-drilldown.component";
import {
  PlanningDraftResourceTableDrilldownComponent
} from "./modules/planning/angular/components/planning-draft-resource-table-drilldown/planning-draft-resource-table-drilldown.component";
import {
  PlanningDefaultDraftsTableComponent
} from "./modules/planning/angular/components/planning-default-drafts-table/planning-default-drafts-table.component";
import {
  PlanningDefaultDraftsTableRowComponent
} from "./modules/planning/angular/components/planning-default-drafts-table-row/planning-default-drafts-table-row.component";
import {
  BringozLabelsDisplayComponent
} from "./modules/commons/angular/components/bringoz-labels-display/bringoz-labels-display.component";
import {
  BringozCapacityBarComponent
} from "./modules/commons/angular/components/bringoz-capacity-bar/bringoz-capacity-bar.component";
import {
  DashboardAgentsRouteScoreTableViewComponent
} from "./modules/dashboards/angular/components/dashboard-agents-route-score-table-view/dashboard-agents-route-score-table-view.component";
import {BreadcrumbsService} from "./modules/commons/angular/services/breadcrumbs.service";
import {
  AgentItineraryEditListComponent
} from "./modules/agents/angular/components/agent-itinerary-edit-list/agent-itinerary-edit-list.component";
import {
  AgentItineraryTaskListComponent
} from "./modules/agents/angular/components/agent-itinerary-task-list/agent-itinerary-task-list.component";
import {
  $branchesProvider,
  $mdDialogProvider,
  $stateServiceProvider,
  $timeoutServiceProvider,
  $windowServiceProvider,
  stateServiceProvider,
  satellizerConfigProvider,
  accountDialogServiceProvider,
  actionReasonsDialogsServiceProvider,
  agentDialogServiceProvider,
  agentsServiceProvider,
  bringozToastServiceProvider,
  bringozUnitConversionServiceProvider,
  commonsDialogServiceProvider,
  commonsServiceProvider,
  dashboardsDialogsServiceProvider,
  dashboardsServiceProvider,
  dateRangeTimeFiltersServiceProvider,
  deliveriesAlertsServiceProvider,
  DeliveriesApiActionProvider,
  deliveriesDialogServiceProvider,
  deliveriesServiceProvider,
  expensesDialogServiceProvider,
  expensesServiceProvider,
  firebaseServiceProvider,
  fulfillmentServiceProvider,
  latLngToAddressProvider,
  locationServiceProvider,
  mapsCommonServiceProvider,
  planningAlertsServiceProvider,
  planningDialogServiceProvider,
  planningCommonServiceProvider,
  pricePlanBundleActionsServiceProvider,
  pricePlanBundleServiceProvider,
  pricePlanDialogServiceProvider,
  printerServiceProvider,
  servicesServiceProvider,
  splitServiceProvider,
  taskRequestsProvider,
  tasksServiceProvider,
  routesServiceProvider,
  viewFilterSettingsServiceProvider,
  batchRecoveryServiceProvider,
  reportsDialogServiceProvider,
  reportsRequestsProvider,
  leanPlanningServiceProvider,
  tagsServiceProvider,
  dashboardsAlertsServiceProvider,
  attachmentsServiceProvider,
  UserServiceProvider, viewSettingsServiceProvider, planningProjectsServiceProvider, confirmDialogServiceProvider,
  schedulingProjectAlertsServiceProvider,
  bringozLoaderServiceProvider, $logProvider, fulfillmentStepRequestsServiceProvider, fulfillmentDialogServiceProvider,
  attachmentsDialogProvider, dateRangeContextServiceProvider, siteContextServiceProvider,
  packageDetailsViewSettingsServiceProvider
} from "./providers";
import {ThreePLModule} from "./modules/threePL/angular/threepl.module";
import {ThreeplTrainVouchersViewComponent} from "./modules/threePL/angular/components/threepl-train-vouchers-view/threepl-train-vouchers-view.component";
import {VouchersPrintPageComponent} from "./modules/threePL/angular/components/vouchers-print-page/vouchers-print-page.component";
import {ThreePLTrainService} from "./modules/threePL/angular/services/threepl-train.service";
import {ThreePLServiceActionsService} from "./modules/threePL/angular/services/threepl-service-actions.service";
import {ThreeplServiceLinkComponent} from "./modules/threePL/angular/components/threepl-service-link/threepl-service-link.component";
import {ThreeplCreateTrainVoucherViewComponent} from "./modules/threePL/angular/components/threepl-create-train-voucher-view/threepl-create-train-voucher-view.component";
import {ThreeplServiceViewComponent} from "./modules/threePL/angular/components/threepl-service-view/threepl-service-view.component";
import {ThreeplServiceTimelineComponent} from "./modules/threePL/angular/components/threepl-service-timeline/threepl-service-timeline.component";
import {ThreeplServiceMapComponent} from "./modules/threePL/angular/components/threepl-service-map/threepl-service-map.component";
import {ThreeplProviderExtraDataViewComponent} from "./modules/threePL/angular/components/threepl-provider-extra-data-view/threepl-provider-extra-data-view.component";
import {ThreeplServicesViewComponent} from "./modules/threePL/angular/components/threepl-services-view/threepl-services-view.component";
import {AccountThreeplServicesComponent} from "./modules/threePL/angular/components/account-threepl-services/account-threepl-services.component";
import {ProviderTypeMultiSelectListComponent} from "./modules/threePL/angular/components/provider-type-multi-select-list/provider-type-multi-select-list.component";
import {ProviderTypesDisplayListComponent} from "./modules/threePL/angular/components/provider-types-display-list/provider-types-display-list.component";
import {
  TaskStatusButtonComponent
} from "./modules/tasks/angular/components/task-status-button/task-status-button.component";
import {AgentsListComponent} from "./modules/agents/angular/components/agents-list/agents-list.component";
import {AgentStatusComponent} from "./modules/agents/angular/components/agent-status/agent-status.component";
import {
  AgentScheduleImportTableComponent
} from "./modules/agents/angular/components/agent-schedule-import-table/agent-schedule-import-table.component";
import {AgentTemperatureComponent} from "./modules/agents/angular/components/agent-temperature/agent-temperature.component";
import {downgradedItinerariesModule} from "./modules/itineraries/angular/itineraries.module";
import {itinerariesFeature} from "./modules/itineraries/angular/state/itineraries.state";
import {ItinerariesFacadeService} from "./modules/itineraries/angular/services/itineraries-facade.service";
import {TasksHttpService} from "./modules/tasks/angular/services/tasks-http.service";
import {
  SsoLoginButtonComponent
} from "./modules/authentication/angular/components/sso-login-button/sso-login-button.component";
import {OAuthModule} from "angular-oauth2-oidc";
import {AuthZeroService} from "./modules/authentication/angular/services/auth-zero.service";
import {SocialOauthRedirectService} from "./modules/authentication/angular/services/social-oauth-redirect.service";
import {
  SsoLogoutButtonComponent
} from "./modules/authentication/angular/components/sso-logout-button/sso-logout-button.component";
import {downgradedLeanPlanningModule} from "./modules/lean-planning/angular/lean-planning.module";
import {
  PlanningRoutesTableComponent
} from "./modules/lean-planning/angular/components/planning-routes-table/planning-routes-table.component";
import {
  RouteAssistantAssignmentComponent
} from "./modules/lean-planning/angular/components/route-assistant-assignment/route-assistant-assignment.component";
import {RoutesFacadeService} from "./modules/lean-planning/angular/services/routes-facade.service";
import {
  PlanningActivityOverviewCardComponent
} from "./modules/planning/angular/components/planning-activity-overview-card/planning-activity-overview-card.component";
import {downgradedRoutesModule} from "./modules/routes/angular/routes.module";
import {
  RouteEditableListComponent
} from "./modules/routes/angular/components/route-editable-list/route-editable-list.component";
import {
  RouteEditableListItemComponent
} from "./modules/routes/angular/components/route-editable-list-item/route-editable-list-item.component";
import {
  PlanningReportsTableComponent
} from "./modules/planning/angular/components/planning-reports-table/planning-reports-table.component";
import {downgradedOrdersModule} from "./modules/oms/angular/orders.module";
import {ordersFeature} from "./modules/oms/angular/state/orders.state";
import {OmsOrdersTableComponent} from "./modules/oms/angular/components/oms-orders-table/oms-orders-table.component";
import {OrdersFacadeService} from "./modules/oms/angular/service/orders-facade.service";
import {OrdersChannelService} from "./modules/oms/angular/service/orders-channel.service";
import {
  PlanningDefaultDraftsFacadeService
} from "./modules/planning/angular/services/planning-default-drafts-facade.service";
import {
  PlanningDraftJobsTableListComponent
} from "./modules/planning/angular/components/planning-draft-jobs-table-list/planning-draft-jobs-table-list.component";
import {
  PlanningDraftRoutesTableListComponent
} from "./modules/planning/angular/components/planning-draft-routes-table-list/planning-draft-routes-table-list.component";
import {
  PlanningDraftResourcesTableListComponent
} from "./modules/planning/angular/components/planning-draft-resources-table-list/planning-draft-resources-table-list.component";
import {
  PlanningDraftJobsPanelEditableListComponent
} from "./modules/planning/angular/components/planning-draft-jobs-panel-editable-list/planning-draft-jobs-panel-editable-list.component";
import {downgradedDepotsModule} from "./modules/depots/angular/depots.module";
import {downgradedCustomersModule} from "./modules/customers/angular/customers.module";
import {
  RoutesPanelListComponent
} from "./modules/routes/angular/components/routes-panel-list/routes-panel-list.component";
import {
  RoutesTableListComponent
} from "./modules/routes/angular/components/routes-table-list/routes-table-list.component";
import {
  RoutesPanelRouteViewComponent
} from "./modules/routes/angular/components/routes-panel-route-view/routes-panel-route-view.component";
import {
  RoutesTableRouteViewComponent
} from "./modules/routes/angular/components/routes-table-route-view/routes-table-route-view.component";
import {
  RoutesTableResourceViewComponent
} from "./modules/routes/angular/components/routes-table-resource-view/routes-table-resource-view.component";
import {
  RoutesPanelListItemComponent
} from "./modules/routes/angular/components/routes-panel-list-item/routes-panel-list-item.component";
import {
  BringozLinearProgressComponent
} from "./modules/commons/angular/components/bringoz-linear-progress/bringoz-linear-progress.component";
import {
  BringozCircularProgressComponent
} from "./modules/commons/angular/components/bringoz-circular-progress/bringoz-circular-progress.component";
import {
  AgentsRouteScoreExpandableTableComponent
} from "./modules/dashboards/angular/components/agents-route-score-expandable-table/agents-route-score-expandable-table.component";
import {
  AgentRoutesPerformanceRowComponent
} from "./modules/dashboards/angular/components/agent-routes-performance-row/agent-routes-performance-row.component";
import {
  RoutesTotalsBarComponent
} from "./modules/routes/angular/components/routes-totals-bar/routes-totals-bar.component";
import {
  BringozExpandableSearchInputComponent
} from "./modules/commons/angular/components/bringoz-expandable-search-input/bringoz-expandable-search-input.component";
import {
  BringozStateLinkComponent
} from "./modules/commons/angular/components/bringoz-state-link/bringoz-state-link.component";
import {OmsOrderLinkComponent} from "./modules/commons/angular/components/oms-order-link/oms-order-link.component";
import {BringozTagsComponent} from "./modules/commons/angular/components/bringoz-tags/bringoz-tags.component";
import {downgradedLogisticsVehicleModule} from "./modules/logistics-vehicle/angular/logistics-vehicle.module";
import {
  LogisticsVehicleLinkComponent
} from "./modules/logistics-vehicle/angular/components/logistics-vehicle-link/logistics-vehicle-link.component";
import {PanelService} from "./modules/commons/angular/services/panel.service";
import {OVERLAY_DEFAULT_CONFIG, OverlayModule} from "@angular/cdk/overlay";
import {
  DemandAccountsMultiSelectComponent
} from "./modules/account/angular/components/demand-accounts-multi-select/demand-accounts-multi-select.component";
import {BatteryStatusComponent} from "./modules/commons/angular/components/battery-status/battery-status.component";
import {BringozChipsComponent} from "./modules/commons/angular/components/bringoz-chips/bringoz-chips.component";
import {FloatingPanelComponent} from "./modules/commons/angular/components/floating-panel/floating-panel.component";
import {
  BringozCountryCodeSelectComponent
} from "./modules/commons/angular/components/bringoz-country-code-select/bringoz-country-code-select.component";
import {
  BringozImagesViewerComponent
} from "./modules/commons/angular/components/bringoz-images-viewer/bringoz-images-viewer.component";
import {SaveFooterComponent} from "./modules/commons/angular/components/save-footer/save-footer.component";
import {
  BringozPrimaryCapacityComponent
} from "./modules/commons/angular/components/bringoz-primary-capacity/bringoz-primary-capacity.component";
import {
  DemandAccountLinkComponent
} from "./modules/account/angular/components/demand-account-link/demand-account-link.component";
import {downgradedTeamsModule} from "./modules/teams/angular/teams.module";
import {TeamsHttpService} from "./modules/teams/angular/services/teams-http.service";
import {TeamsTableComponent} from "./modules/teams/angular/components/teams-table/teams-table.component";
import {
  BringozPackageSelectListComponent
} from "./modules/commons/angular/components/bringoz-package-select-list/bringoz-package-select-list.component";
import {
  ServicesPanelListComponent
} from "./modules/deliveries/angular/components/services-panel-list/services-panel-list.component";
import {
  ServicesTableListComponent
} from "./modules/deliveries/angular/components/services-table-list/services-table-list.component";
import {
  AddressQualityComponent
} from "./modules/addresses/angular/components/address-quality/address-quality.component";
import {
  AdminAutocompleteInputComponent
} from "./modules/admins/angular/components/admin-autocomplete-input/admin-autocomplete-input.component";
import {
  ContactPersonsTableComponent
} from "./modules/admins/angular/components/contact-persons-table/contact-persons-table.component";
import {
  BringozDatePickerComponent
} from "./modules/commons/angular/components/bringoz-date-picker/bringoz-date-picker.component";
import {
  BringozTimeSelectComponent
} from "./modules/commons/angular/components/bringoz-time-select/bringoz-time-select.component";
import {DocumentEditComponent} from "./modules/commons/angular/components/document-edit/document-edit.component";
import {
  BringozCustomizedTableColumnsSettingsComponent
} from "./modules/commons/angular/components/bringoz-customized-table-columns-settings/bringoz-customized-table-columns-settings.component";
import {
  BringozDatesTimeRangeComponent
} from "./modules/commons/angular/components/bringoz-dates-time-range/bringoz-dates-time-range.component";
import {
  BringozDatetimeRangeComponent
} from "./modules/commons/angular/components/bringoz-datetime-range/bringoz-datetime-range.component";
import {downgradedAdminsModule} from "./modules/admins/angular/admins.module";
import {downgradedAgentInventoryModule} from "./modules/agent-inventory/angular/agent-inventory.module";
import {SitePreferencesAngularModule} from "./modules/site-preferences/angular/site-preferences.module";
import {
  SiteProvidersViewComponent
} from "./modules/site-preferences/angular/components/site-providers-view/site-providers-view.component";
import {
  SettingsAuditLogComponent
} from "./modules/site-preferences/angular/components/settings-audit-log/settings-audit-log.component";
import {AgentInventorySettingsTableComponent} from "./modules/agent-inventory/angular/components/agent-inventory-settings-table/agent-inventory-settings-table.component";
import {TermsModule} from "./modules/terms/angular/terms.module";
import {TermsViewComponent} from "./modules/terms/angular/components/terms-view/terms-view.component";
import {ExpandButtonComponent} from "./modules/commons/angular/components/expand-button/expand-button.component";
import {
  PlanningProjectDraftSelectComponent
} from "./modules/planning/angular/components/planning-project-draft-select/planning-project-draft-select.component";
import {SiteNavMenuService} from "./modules/commons/angular/services/site-nav-menu.service";
import {
  PlanningProjectsSelectComponent
} from "./modules/planning/angular/components/planning-projects-select/planning-projects-select.component";
import {
  BringozSiteNavToggleComponent
} from "./modules/commons/angular/components/bringoz-site-nav-toggle/bringoz-site-nav-toggle.component";
import {
  BringozOperationalContactsTableComponent
} from "./modules/commons/angular/components/bringoz-operational-contacts-table/bringoz-operational-contacts-table.component";
import {
  BringozOperationalContactsTableRowComponent
} from "./modules/commons/angular/components/bringoz-operational-contacts-table-row/bringoz-operational-contacts-table-row.component";
import {
  TaskDetailedServiceTimeComponent
} from "./modules/tasks/angular/components/task-detailed-service-time/task-detailed-service-time.component";
import {downgradedSchedulingProjectModule} from "./modules/scheduling-project/angular/scheduling-project.module";
import {
  VisitPlanCardInfoComponent
} from "./modules/scheduling-project/angular/components/visit-plan-card-info/visit-plan-card-info.component";
import {downgradedRecommendationModule} from "./modules/recommendation/angular/recommendation.module";
import {RecommendationWidgetComponent} from "./modules/recommendation/angular/components/recommendation-widget/recommendation-widget.component";
import {
  RecommendationPanelLayoutComponent
} from "./modules/recommendation/angular/components/recommendation-panel-layout/recommendation-panel-layout.component";
import {
  VisitPlanMetricWidgetComponent
} from "./modules/scheduling-project/angular/components/visit-plan-metric-widget/visit-plan-metric-widget.component";
import {
  VisitPlanAccountsTableComponent
} from "./modules/scheduling-project/angular/components/visit-plan-accounts-table/visit-plan-accounts-table.component";
import {
  AvailabilityTableComponent
} from "./modules/scheduling-project/angular/components/availability-table/availability-table.component";
import {VisitPlanFacadeService} from "./modules/scheduling-project/angular/services/visit-plan-facade.service";
import {
  VisitPlanAccountFacadeService
} from "./modules/scheduling-project/angular/services/visit-plan-account-facade.service";
import {
  visitPlanAccountFeature
} from "./modules/scheduling-project/angular/state/visit-plan-account-state/visit-plan-account.state";
import {
  VisitConfigurationsTableComponent
} from "./modules/scheduling-project/angular/components/visit-configurations-table/visit-configurations-table.component";
import {
  VisitConfigurationFacadeService
} from "./modules/scheduling-project/angular/services/visit-configuration-facade.service";
import {VisitConfigurationHttpService} from "./modules/scheduling-project/angular/services/visit-configuration-http.service";
import {
  visitConfigurationsFeature
} from "./modules/scheduling-project/angular/state/visit-configuration-state/visit-configuration.state";
import {ToastsContainer} from "./modules/commons/angular/components/bringoz-toast/bringoz-toast.component";
import {downgradedSubTasksModule} from "./modules/sub-tasks/angular/sub-tasks.module";
import {
  VisitPlanTrackerChangesViewComponent
} from "./modules/scheduling-project/angular/components/visit-plan-tracker-changes-view/visit-plan-tracker-changes-view.component";
import {
  SchedulingProjectReportsTableComponent
} from "./modules/scheduling-project/angular/components/scheduling-project-reports-table/scheduling-project-reports-table.component";
import {
  SchedulingProjectVisitPlansTableComponent
} from "./modules/scheduling-project/angular/components/scheduling-project-visit-plans-table/scheduling-project-visit-plans-table.component";
import {
  visitPlanJobFeature
} from "./modules/scheduling-project/angular/state/visit-plan-job-state/visit-plan-job.state";
import {
  visitScheduleFeature
} from "./modules/scheduling-project/angular/state/visit-plan-schedule-state/visit-plan-schedule.state";
import {
  VisitPlanJobsPanelComponent
} from "./modules/scheduling-project/angular/components/visit-plan-jobs-panel/visit-plan-jobs-panel.component";
import {
  VisitPlanScheduleFacadeService
} from "./modules/scheduling-project/angular/services/visit-plan-schedule-facade.service";
import {
  VisitPlanPanelsComponent
} from "./modules/scheduling-project/angular/components/visit-plan-panels/visit-plan-panels.component";
import {downgradedBranchesModule} from "./modules/branches/angular/branches.module";
import {
  VisitScheduleAgentsListComponent
} from "./modules/scheduling-project/angular/components/visit-schedule-agents-list/visit-schedule-agents-list.component";
import {VisitPlanHttpService} from "./modules/scheduling-project/angular/services/visit-plan-http.service";
import {downgradedScheduleModule} from "./modules/schedule/angular/schedule.module";
import {VisitScheduleFacadeService} from "./modules/scheduling-project/angular/services/visit-schedule-facade.service";
import {AiAgentsTableComponent} from "./modules/ai-agents/angular/components/ai-agents-table/ai-agents-table.component";
import {AiAgentsHttpService} from "./modules/ai-agents/angular/services/ai-agents-http.service";
import {downgradedAiAgentsModule} from "./modules/ai-agents/angular/ai-agents.module";
import {
  RecommendationGroupsPanelLayoutComponent
} from "./modules/recommendation/angular/components/recommendation-groups-panel-layout/recommendation-groups-panel-layout.component";
import {DepotsFacadeService} from "./modules/depots/angular/services/depots-facade.service";
import {
  VisitScheduleRoutesChannelService
} from "./modules/scheduling-project/angular/services/visit-schedule-routes-channel.service";
import {ExpensesHttpService} from "./modules/expenses/services/expenses-http-service.service";
import {BatchRecoveryHttpService} from "./modules/batch/angular/services/batch-recovery-http.service";
import {SiteProvidersService} from "./modules/site-preferences/angular/services/site-providers.service";
import {MapUtilsService} from "./modules/commons/angular/services/map-utils.service";
import {
  ResourcesPanelListComponent
} from "./modules/resources/angular/components/resources-panel-list/resources-panel-list.component";
import {
  ResourcesTableListComponent
} from "./modules/resources/angular/components/resources-table-list/resources-table-list.component";
import {
  RoutesPanelResourceViewComponent
} from "./modules/routes/angular/components/routes-panel-resource-view/routes-panel-resource-view.component";
import {ResourcesHttpService} from "./modules/resources/angular/services/resources-http.service";
import {AccountsHttpService} from "./modules/account/angular/services/accounts-http.service";
import {
  VisitPlanInfoTooltipComponent
} from "./modules/scheduling-project/angular/components/visit-plan-info-tooltip/visit-plan-info-tooltip.component";


@NgModule({
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    UpgradeModule,
    NgbModule,
    NgbTooltipModule,
    NgbToastModule,
    ChatModule,
    ThreePLModule,
    ScrollingModule,
    CommonsModule,
    StoreModule.forRoot({commons}),
    StoreModule.forFeature(accountsFeature),
    StoreModule.forFeature(locationsFeature),
    StoreModule.forFeature(agentsFeature),
    StoreModule.forFeature(chatFeature),
    StoreModule.forFeature(addressFeature),
    StoreModule.forFeature(servicesFeature),
    StoreModule.forFeature(tasksFeature),
    StoreModule.forFeature(fulfillmentFeature),
    StoreModule.forFeature(itinerariesFeature),
    StoreModule.forFeature(routesFeature),
    StoreModule.forFeature(ordersFeature),
    StoreModule.forFeature(visitPlanFeature),
    StoreModule.forFeature(visitPlanAccountFeature),
    StoreModule.forFeature(visitConfigurationsFeature),
    StoreModule.forFeature(visitPlanJobFeature),
    StoreModule.forFeature(visitScheduleFeature),
    AngularSvgIconModule.forRoot(), // angular-svg-icon library module
    // AngularSvgIconPreloaderModule.forRoot({
    //   configUrl: '/assets/bringoz-icons.json',
    // }),
    // Instrumentation must be imported after importing StoreModule (config is optional)
    // StoreDevtoolsModule.instrument({
    //   name: 'Bringoz - Console',
    //   maxAge: 25, // Retains last 25 states
    //   // logOnly: !isDevMode(), // Restrict extension to log-only mode
    //   logOnly: false, // Restrict extension to log-only mode
    //   autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    //   trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
    //   traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
    // }),
    OAuthModule.forRoot(),
    TranslateModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    EffectsModule.forRoot([accountsEffects, locationsEffects, agentsEffects, servicesEffects, tasksEffects, fulfillmentEffects,
      itineraryEffects, routesEffects, ordersEffects, visitPlanEffects, visitPlanAccountEffects, visitConfigurationEffects, visitPlanJobEffects,
      visitScheduleEffects]),
    PlanningModule,
    SitePreferencesAngularModule,
    TimekeepingAngularModule,
    TermsModule,
    NgxEchartsModule.forRoot({echarts}),
    OverlayModule
  ],
  declarations: [
    BootstrapAngularComponent,
    ToastsContainer,
    SsoLoginButtonComponent,
    SsoLogoutButtonComponent
    // LoaderComponent
  ],
  providers: [
    // From CDK 19 on, an overlay is shown through the native Popover API, which puts it in the
    // browser's top layer. Nothing in the normal layer can paint above a top-layer element at any
    // z-index, so every ngbTooltip/ngbDropdown/ngbPopover with container="body" that is rendered
    // inside a panel becomes invisible behind it. This app predates that model - it hand-tunes
    // stacking instead (see body.audit-log-active .cdk-overlay-container) - so overlays stay in
    // the normal layer until that layering is revisited deliberately.
    {provide: OVERLAY_DEFAULT_CONFIG, useValue: {usePopover: false}},
    AuthZeroService,
    AccountsChanelService,
    AccountsFacadeService,
    LocationsChanelService,
    LocationsFacadeService,
    AgentsChanelService,
    AgentsFacadeService,
    DepotsFacadeService,
    ChatFacadeService,
    ChatService,
    BreadcrumbsService,
    SiteNavMenuService,
    ServicesChanelService,
    ServicesFacadeService,
    AddToRouteComponentStore,
    RoutesFacadeService,
    AddressFacadeService,
    TasksChannelService,
    TasksFacadeService,
    FulfillmentChannelService,
    FulfillmentFacadeService,
    ItinerariesFacadeService,
    OrdersFacadeService,
    OrdersChannelService,
    TranslationsService,
    PlanningDefaultDraftsFacadeService,
    PlanningDraftJobChangesFacadeService,
    VisitPlanFacadeService,
    VisitPlanAccountFacadeService,
    VisitConfigurationFacadeService,
    VisitPlanScheduleFacadeService,
    VisitScheduleFacadeService,
    VisitScheduleRoutesChannelService,
    ExpensesHttpService,
    BatchRecoveryHttpService,
    // [{provide: Injector, useValue: AuthInterceptor}],
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    firebaseServiceProvider,
    $stateServiceProvider,
    splitServiceProvider,
    planningCommonServiceProvider,
    bringozToastServiceProvider,
    $timeoutServiceProvider,
    deliveriesDialogServiceProvider,
    deliveriesServiceProvider,
    $mdDialogProvider,
    commonsServiceProvider,
    $windowServiceProvider,
    stateServiceProvider,
    satellizerConfigProvider,
    DeliveriesApiActionProvider,
    printerServiceProvider,
    servicesServiceProvider,
    commonsDialogServiceProvider,
    expensesDialogServiceProvider,
    expensesServiceProvider,
    fulfillmentServiceProvider,
    dashboardsServiceProvider,
    agentDialogServiceProvider,
    agentsServiceProvider,
    locationServiceProvider,
    latLngToAddressProvider,
    pricePlanBundleActionsServiceProvider,
    pricePlanDialogServiceProvider,
    pricePlanBundleServiceProvider,
    accountDialogServiceProvider,
    mapsCommonServiceProvider,
    dashboardsDialogsServiceProvider,
    planningAlertsServiceProvider,
    planningDialogServiceProvider,
    $branchesProvider,
    dateRangeTimeFiltersServiceProvider,
    taskRequestsProvider,
    tasksServiceProvider,
    actionReasonsDialogsServiceProvider,
    deliveriesAlertsServiceProvider,
    bringozUnitConversionServiceProvider,
    routesServiceProvider,
    viewFilterSettingsServiceProvider,
    batchRecoveryServiceProvider,
    reportsDialogServiceProvider,
    reportsRequestsProvider,
    leanPlanningServiceProvider,
    tagsServiceProvider,
    attachmentsServiceProvider,
    UserServiceProvider,
    dashboardsAlertsServiceProvider,
    viewSettingsServiceProvider,
    planningProjectsServiceProvider,
    confirmDialogServiceProvider,
    schedulingProjectAlertsServiceProvider,
    bringozLoaderServiceProvider,
    $logProvider,
    fulfillmentStepRequestsServiceProvider,
    fulfillmentDialogServiceProvider,
    attachmentsDialogProvider,
    dateRangeContextServiceProvider,
    siteContextServiceProvider,
    packageDetailsViewSettingsServiceProvider
  ]
})
export class AppModule {

  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapAppModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AppModule);
};

const downgradedAppModule = downgradeModule(bootstrapAppModule);

// Wrapper to prevent the "Downgraded module has not been bootstrapped yet" race condition
// by deferring the actual resolution of the Angular service until it is accessed. AngularJS's
// ui-router can start resolving states (and calling into a downgraded service) before Angular's
// own async bootstrap - triggered lazily by the first downgraded component AngularJS links - has
// actually finished. Rather than letting that throw, method calls made before the instance is
// ready are queued and replayed in order once bootstrap resolves, so callers that fire-and-forget
// (e.g. store.dispatch(...)) still take effect instead of silently vanishing.
function lazyDowngradeInjectable(token: any, moduleName: string) {
  const factoryFn = downgradeInjectable(token, moduleName) as Function;
  const tokenName = (token && token.name) || moduleName;

  return ['$injector', function ($injector: any) {
    let instance: any = null;
    let pendingOps: ({ type: 'call', prop: string | symbol, args: any[] } | { type: 'set', prop: string | symbol, value: any })[] = [];
    let pollAttempts = 0;
    const MAX_POLL_ATTEMPTS = 250; // ~5s at 20ms intervals

    function tryGetInstance() {
      if (!instance) {
        try {
          instance = factoryFn($injector);
        } catch (e) {
          // Angular hasn't bootstrapped yet - caller will be queued instead.
        }
      }
      return instance;
    }

    function flushPendingOps() {
      if (!tryGetInstance() || !pendingOps.length) {
        return;
      }
      const ops = pendingOps;
      pendingOps = [];
      for (const op of ops) {
        if (op.type === 'call') {
          instance[op.prop](...op.args);
        } else {
          instance[op.prop] = op.value;
        }
      }
    }

    function pollUntilReady() {
      if (tryGetInstance()) {
        flushPendingOps();
        return;
      }
      pollAttempts++;
      if (pollAttempts > MAX_POLL_ATTEMPTS) {
        console.error(`lazyDowngradeInjectable(${tokenName}): Angular never bootstrapped after ${MAX_POLL_ATTEMPTS * 20}ms - dropping ${pendingOps.length} queued call(s)/set(s).`);
        pendingOps = [];
        return;
      }
      setTimeout(pollUntilReady, 20);
    }

    function enqueue(op: { type: 'call', prop: string | symbol, args: any[] } | { type: 'set', prop: string | symbol, value: any }) {
      const wasEmpty = !pendingOps.length;
      pendingOps.push(op);
      if (wasEmpty) {
        pollAttempts = 0;
        pollUntilReady();
      }
    }

    const target = (token && token.prototype) ? Object.create(token.prototype) : {};
    return new Proxy(target, {
      get: function (target, prop) {
        if (tryGetInstance()) {
          const val = instance[prop];
          return typeof val === 'function' ? val.bind(instance) : val;
        }
        // Not ready yet - hand back a stand-in for the (assumed) method call that queues it.
        return (...args: any[]) => {
          if (tryGetInstance()) {
            return instance[prop](...args);
          }
          enqueue({type: 'call', prop, args});
        };
      },
      set: function (target, prop, value) {
        if (tryGetInstance()) {
          instance[prop] = value;
        } else {
          enqueue({type: 'set', prop, value});
        }
        return true;
      },
      getPrototypeOf: function() {
        tryGetInstance();
        return Object.getPrototypeOf(instance || target);
      }
    });
  }];
}

const app = angular
  .module('app', [
    'ngMaterial',
    'ui.router',
    'triangular',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngMessages',
    // 'hmTouchEvents',
    'googlechart',
    'linkify',
    'ui.calendar',
    'angularMoment',
    'uiGmapgoogle-maps',
    'md.data.table',
    // 'signature',
    'ngFileUpload',
    // 'nvd3',
    'zxcvbn',
    'isoCurrency',
    'app.translate',
    'app.permission',
    'bringoz.admin'
  ])

const ngApp = angular.module('ngApp', [
  downgradedAppModule,
  downgradedAccountModule,
  downgradedAgentsModule,
  downgradedAddressesModule,
  downgradedServicesModule,
  downgradedResourcesModule,
  downgradedTasksModule,
  downgradedDashboardsModule,
  downgradedPricePlanModule,
  downgradedGroupsModule,
  downgradedMapModule,
  downgradedLogisticsVehicleModule,
  downgradedItinerariesModule,
  downgradedLeanPlanningModule,
  downgradedRoutesModule,
  downgradedOrdersModule,
  downgradedDepotsModule,
  downgradedCustomersModule,
  downgradedTeamsModule,
  downgradedAdminsModule,
  downgradedAgentInventoryModule,
  downgradedSchedulingProjectModule,
  downgradedSubTasksModule,
  downgradedBranchesModule,
  downgradedScheduleModule,
  downgradedRecommendationModule,
  downgradedAiAgentsModule,
  'app'
])

// @bringoz/ui components used directly from AngularJS templates.
// Only leaf controls belong here: anything whose API is an <ng-template>
// (bz-table) cannot be expressed in an AngularJS template and has to go
// through an Angular component of ours instead.
ngApp.directive('bzButton', downgradeComponent({
  component: BzButton,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bzSpinner', downgradeComponent({
  component: BzSpinner,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)

// Main
ngApp.directive('bootstrap', downgradeComponent({
  component: BootstrapAngularComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bringozToasts', downgradeComponent({
  component: ToastsContainer,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)

// Agent Inventory Components
ngApp.directive('appAgentInventorySettingsTable', downgradeComponent({
  component: AgentInventorySettingsTableComponent,
  downgradedModule: downgradedAgentInventoryModule
}) as angular.IDirectiveFactory)

// Timekeeping Components
ngApp.directive('appTimekeepingView', downgradeComponent({
  component: TimekeepingViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appTimecardDetail', downgradeComponent({
  component: TimecardDetailComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)

ngApp.directive('loader', downgradeComponent({
  component: LoaderComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bringozButton', downgradeComponent({
  component: BringozButtonComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bringozCheckbox', downgradeComponent({
  component: BringozCheckboxComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bringozToggle', downgradeComponent({
  component: BringozToggleComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bringozSwitch', downgradeComponent({
  component: BringozSwitchComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('bringozIcon', downgradeComponent({
  component: BringozIconComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozSearchInput', downgradeComponent({
  component: BringozSearchInputComponent,
  downgradedModule: downgradedAppModule,
  outputs: ['queryChangeEvent']
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozPrimaryCapacity', downgradeComponent({
  component: BringozPrimaryCapacityComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozCapacityBarComponent', downgradeComponent({
  component: BringozCapacityBarComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozLinearProgressComponent', downgradeComponent({
  component: BringozLinearProgressComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozCircularProgress', downgradeComponent({
  component: BringozCircularProgressComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozLabelsDisplayComponent', downgradeComponent({
  component: BringozLabelsDisplayComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.factory('store', lazyDowngradeInjectable(Store, downgradedAppModule));
ngApp.factory('translate', lazyDowngradeInjectable(TranslateService, downgradedAppModule));
ngApp.factory('permissionsService', lazyDowngradeInjectable(NgxPermissionsService, downgradedAppModule))
ngApp.factory('ngxRolesService', lazyDowngradeInjectable(NgxRolesService, downgradedAppModule))
ngApp.factory('firebaseAppService', lazyDowngradeInjectable(FirebaseAppService, downgradedAppModule));
ngApp.factory('socialOauthRedirectService', lazyDowngradeInjectable(SocialOauthRedirectService, downgradedAppModule));

// Accounts
ngApp.factory('accountsChanelService', lazyDowngradeInjectable(AccountsChanelService, downgradedAppModule));
ngApp.factory('accountsFacadeService', lazyDowngradeInjectable(AccountsFacadeService, downgradedAppModule));

// Agents
ngApp.factory('agentsChanelService', lazyDowngradeInjectable(AgentsChanelService, downgradedAppModule))
ngApp.factory('agentsFacadeService', lazyDowngradeInjectable(AgentsFacadeService, downgradedAppModule))
ngApp.directive('appAgentLocation', downgradeComponent({
  component: AgentLocationComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appAgentItineraryTaskList', downgradeComponent({
  component: AgentItineraryTaskListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appAgentsList', downgradeComponent({
  component: AgentsListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appAgentStatus', downgradeComponent({
  component: AgentStatusComponent,
  downgradedModule: downgradedAgentsModule
}) as angular.IDirectiveFactory)
ngApp.directive('appAgentScheduleImportTable', downgradeComponent({
  component: AgentScheduleImportTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appAgentTemperature', downgradeComponent({
  component: AgentTemperatureComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)

// Chat
ngApp.factory('chatFacadeService', lazyDowngradeInjectable(ChatFacadeService, downgradedAppModule))
ngApp.factory('chatService', lazyDowngradeInjectable(ChatService, downgradedAppModule))
ngApp.factory('chatHttpService', lazyDowngradeInjectable(ChatHttpService, downgradedAppModule))
ngApp.directive('chatView', downgradeComponent({
  component: ChatViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('chatConversationServiceView', downgradeComponent({
  component: ChatConversationServiceViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)

// Addresses
ngApp.factory('addressFacadeService', lazyDowngradeInjectable(AddressFacadeService, downgradedAppModule));

ngApp.directive('appAddressQuality', downgradeComponent({
  component: AddressQualityComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)

// Logistics Vehicle
ngApp.directive('appLogisticsVehicleLink', downgradeComponent({
  component: LogisticsVehicleLinkComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Locations
ngApp.factory('locationsChanelService', lazyDowngradeInjectable(LocationsChanelService, downgradedAppModule));
ngApp.factory('locationsFacadeService', lazyDowngradeInjectable(LocationsFacadeService, downgradedAppModule));

// Services
ngApp.factory('servicesChanelService', lazyDowngradeInjectable(ServicesChanelService, downgradedAppModule));
ngApp.factory('servicesFacadeService', lazyDowngradeInjectable(ServicesFacadeService, downgradedAppModule));
ngApp.factory('addToRouteStore', lazyDowngradeInjectable(AddToRouteComponentStore, downgradedAppModule));
ngApp.directive('appServiceTypeIndication', downgradeComponent({
  component: ServiceTypeIndicationComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appServicesTable', downgradeComponent({
  component: ServicesTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Tasks
ngApp.factory('tasksChannelService', lazyDowngradeInjectable(TasksChannelService, downgradedAppModule));
ngApp.factory('tasksFacadeService', lazyDowngradeInjectable(TasksFacadeService, downgradedAppModule));
ngApp.factory('tasksHttpService', lazyDowngradeInjectable(TasksHttpService, downgradedAppModule))
ngApp.directive('appTaskStatusButton', downgradeComponent({
  component: TaskStatusButtonComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appTaskDetailedServiceTime', downgradeComponent({
  component: TaskDetailedServiceTimeComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

//Accounts
ngApp.directive('appDemandAccountLink', downgradeComponent({
  component: DemandAccountLinkComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appDemandAccountTable', downgradeComponent({
  component: DemandAccountTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appDemandAccountsMultiSelect', downgradeComponent({
  component: DemandAccountsMultiSelectComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

//Commons
ngApp.directive('bringozTooltip', downgradeComponent({
  component: BringozTooltipComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozDonutChart', downgradeComponent({
  component: BringozDonutChartComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozItemsListDisplay', downgradeComponent({
  component: BringozItemsListDisplayComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozPagination', downgradeComponent({
  component: BringozPaginationComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozCheckbox', downgradeComponent({
  component: BringozCheckboxComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozDurationMinsHoursInput', downgradeComponent({
  component: BringozDurationMinsHoursInputComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozExpandableSearchInput', downgradeComponent({
  component: BringozExpandableSearchInputComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozStateLink', downgradeComponent({
  component: BringozStateLinkComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozTags', downgradeComponent({
  component: BringozTagsComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBatteryStatus', downgradeComponent({
  component: BatteryStatusComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozChips', downgradeComponent({
  component: BringozChipsComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozCountryCodeSelect', downgradeComponent({
  component: BringozCountryCodeSelectComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozImagesViewer', downgradeComponent({
  component: BringozImagesViewerComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appSaveFooter', downgradeComponent({
  component: SaveFooterComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozPackageSelectList', downgradeComponent({
  component: BringozPackageSelectListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozDatePicker', downgradeComponent({
  component: BringozDatePickerComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozTimeSelect', downgradeComponent({
  component: BringozTimeSelectComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appDocumentEdit', downgradeComponent({
  component: DocumentEditComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozCustomizedTableColumnsSettings', downgradeComponent({
  component: BringozCustomizedTableColumnsSettingsComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozDatesTimeRange', downgradeComponent({
  component: BringozDatesTimeRangeComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory)
ngApp.directive('appBringozDatetimeRange', downgradeComponent({
  component: BringozDatetimeRangeComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appExpandButton', downgradeComponent({
  component: ExpandButtonComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozSiteNavToggle', downgradeComponent({
  component: BringozSiteNavToggleComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appBringozOperationalContactsTable', downgradeComponent({
  component: BringozOperationalContactsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appBringozOperationalContactsTableRow', downgradeComponent({
  component: BringozOperationalContactsTableRowComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.factory('breadcrumbsService', lazyDowngradeInjectable(BreadcrumbsService, downgradedAppModule))
ngApp.factory('siteNavMenuService', lazyDowngradeInjectable(SiteNavMenuService, downgradedAppModule))
ngApp.factory('commonsFacadeService', lazyDowngradeInjectable(CommonsFacadeService, downgradedAppModule));
ngApp.factory('translationsService', lazyDowngradeInjectable(TranslationsService, downgradedAppModule));
ngApp.factory('panelService', lazyDowngradeInjectable(PanelService, downgradedAppModule));
ngApp.factory('mapUtilsService', lazyDowngradeInjectable(MapUtilsService, downgradedAppModule));

//Fulfillment
ngApp.factory('fulfillmentChannelService', lazyDowngradeInjectable(FulfillmentChannelService, downgradedAppModule));
ngApp.factory('fulfillmentFacadeService', lazyDowngradeInjectable(FulfillmentFacadeService, downgradedAppModule));


//Dashboards
ngApp.directive('appDashboardView', downgradeComponent({
  component: DashboardViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appDashboardAgentsTableView', downgradeComponent({
  component: DashboardAgentsTableViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appDashboardServicesTableView', downgradeComponent({
  component: DashboardServicesTableViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appDashboardAgentsRouteScoreTableView', downgradeComponent({
  component: DashboardAgentsRouteScoreTableViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appAgentsRouteScoreExpandableTable', downgradeComponent({
  component: AgentsRouteScoreExpandableTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appAgentRoutesPerformanceRow', downgradeComponent({
  component: AgentRoutesPerformanceRowComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

//Price plan
ngApp.directive('appPricePlanBundleStateView', downgradeComponent({
  component: PricePlanBundleStateViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

//Groups
ngApp.directive('appGroupsTable', downgradeComponent({
  component: GroupsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appGroupsColorDisplayList', downgradeComponent({
  component: GroupsColorDisplayListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.factory('groupsHttpService', lazyDowngradeInjectable(GroupsHttpService, downgradedAppModule));

//Teams
ngApp.factory('teamsHttpService', lazyDowngradeInjectable(TeamsHttpService, downgradedAppModule));
ngApp.directive('appTeamsTable', downgradeComponent({
  component: TeamsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Maps
ngApp.directive('appAgentsMap', downgradeComponent({
  component: AgentsMapComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Planning
ngApp.directive('appPlanningDraftJobsPanelList', downgradeComponent({
  component: PlanningDraftJobsPanelListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftJobChangesList', downgradeComponent({
  component: PlanningDraftJobChangesListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftJobsPanelEditableList', downgradeComponent({
  component: PlanningDraftJobsPanelEditableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftJobsTableList', downgradeComponent({
  component: PlanningDraftJobsTableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftRoutesTableList', downgradeComponent({
  component: PlanningDraftRoutesTableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftResourcesTableList', downgradeComponent({
  component: PlanningDraftResourcesTableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftRouteTableDrilldown', downgradeComponent({
  component: PlanningDraftRouteTableDrilldownComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftResourceTableDrilldown', downgradeComponent({
  component: PlanningDraftResourceTableDrilldownComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftJobsPanelListItem', downgradeComponent({
  component: PlanningDraftJobsPanelListItemComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftRoutesPanelList', downgradeComponent({
  component: PlanningDraftRoutesPanelListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftRoutesPanelListItem', downgradeComponent({
  component: PlanningDraftRoutesPanelListItemComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftResourcesPanelList', downgradeComponent({
  component: PlanningDraftResourcesPanelListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftResourcesPanelListItem', downgradeComponent({
  component: PlanningDraftResourcesPanelListItemComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftResourcePanelView', downgradeComponent({
  component: PlanningDraftResourcePanelViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDraftRoutePanelViewTest', downgradeComponent({
  component: PlanningDraftRoutePanelViewTestComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningActivityOverviewCard', downgradeComponent({
  component: PlanningActivityOverviewCardComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningReportsTable', downgradeComponent({
  component: PlanningReportsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDefaultDraftsTable', downgradeComponent({
  component: PlanningDefaultDraftsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningDefaultDraftsTableRow', downgradeComponent({
  component: PlanningDefaultDraftsTableRowComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningProjectDraftSelect', downgradeComponent({
  component: PlanningProjectDraftSelectComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningProjectsSelect', downgradeComponent({
  component: PlanningProjectsSelectComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appFloatingPanel', downgradeComponent({
  component: FloatingPanelComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Agents / Itineraries
ngApp.directive('appAgentItineraryEditList', downgradeComponent({
  component: AgentItineraryEditListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.factory('itinerariesFacadeService', lazyDowngradeInjectable(ItinerariesFacadeService, downgradedAppModule));

// Authentication
ngApp.directive('appSsoLoginButton', downgradeComponent({
  component: SsoLoginButtonComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appSsoLogoutButton', downgradeComponent({
  component: SsoLogoutButtonComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

//Routes
ngApp.directive('appRouteAssistantAssignment', downgradeComponent({
  component: RouteAssistantAssignmentComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appPlanningRoutesTable', downgradeComponent({
  component: PlanningRoutesTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRouteEditableList', downgradeComponent({
  component: RouteEditableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRouteEditableListItem', downgradeComponent({
  component: RouteEditableListItemComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesPanelList', downgradeComponent({
  component: RoutesPanelListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesTableList', downgradeComponent({
  component: RoutesTableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesPanelRouteView', downgradeComponent({
  component: RoutesPanelRouteViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesTableRouteView', downgradeComponent({
  component: RoutesTableRouteViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesPanelResourceView', downgradeComponent({
  component: RoutesPanelResourceViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesTableResourceView', downgradeComponent({
  component: RoutesTableResourceViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesPanelListItem', downgradeComponent({
  component: RoutesPanelListItemComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appRoutesTotalsBar', downgradeComponent({
  component: RoutesTotalsBarComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.factory('routesFacadeService', lazyDowngradeInjectable(RoutesFacadeService, downgradedAppModule));

//orders
ngApp.directive('appOmsOrdersTable', downgradeComponent({
  component: OmsOrdersTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appOmsOrderLink', downgradeComponent({
  component: OmsOrderLinkComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.factory('ordersFacadeService', lazyDowngradeInjectable(OrdersFacadeService, downgradedAppModule));
ngApp.factory('planningDefaultDraftsFacadeService', lazyDowngradeInjectable(PlanningDefaultDraftsFacadeService, downgradedAppModule));
ngApp.factory('planningDraftJobChangesFacadeService', lazyDowngradeInjectable(PlanningDraftJobChangesFacadeService, downgradedAppModule));
ngApp.factory('planningDraftJobChangesHttpService', lazyDowngradeInjectable(PlanningDraftJobChangesHttpService, downgradedAppModule));
ngApp.factory('planningDragAndDropService', lazyDowngradeInjectable(PlanningDragAndDropService, downgradedAppModule));

//Timekeeping
ngApp.factory('timekeepingHttpService', lazyDowngradeInjectable(TimekeepingHttpService, downgradedAppModule));
ngApp.factory('branchesHttpService', lazyDowngradeInjectable(BranchesHttpService, downgradedAppModule));

//Services
ngApp.directive('appServicesPanelList', downgradeComponent({
  component: ServicesPanelListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appServicesTableList', downgradeComponent({
  component: ServicesTableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);


//Resources
ngApp.directive('appResourcesPanelList', downgradeComponent({
  component: ResourcesPanelListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appResourcesTableList', downgradeComponent({
  component: ResourcesTableListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.factory('resourcesHttpService', lazyDowngradeInjectable(ResourcesHttpService, downgradedAppModule))

//Auth
ngApp.factory('authZeroService', lazyDowngradeInjectable(AuthZeroService, downgradedAppModule));


//Admins
ngApp.directive('appAdminAutocompleteInput', downgradeComponent({
  component: AdminAutocompleteInputComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appContactPersonsTable', downgradeComponent({
  component: ContactPersonsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Scheduling Project
ngApp.directive('appVisitPlanCardInfo', downgradeComponent({
  component: VisitPlanCardInfoComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appVisitPlanAccountsTable', downgradeComponent({
  component: VisitPlanAccountsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appAvailabilityTable', downgradeComponent({
  component: AvailabilityTableComponent,
  downgradedModule: downgradedAppModule,
  outputs: ['onInstanceReady']
}) as angular.IDirectiveFactory);

ngApp.directive('appVisitConfigurationsTable', downgradeComponent({
  component: VisitConfigurationsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);


ngApp.directive('appVisitPlanTrackerChangesView', downgradeComponent({
  component: VisitPlanTrackerChangesViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appSchedulingProjectReportsTable', downgradeComponent({
  component: SchedulingProjectReportsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appSchedulingProjectVisitPlansTable', downgradeComponent({
  component: SchedulingProjectVisitPlansTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appVisitPlanJobsPanel', downgradeComponent({
  component: VisitPlanJobsPanelComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appVisitPlanJobsPanel', downgradeComponent({
  component: VisitPlanJobsPanelComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
ngApp.directive('appVisitPlanPanels', downgradeComponent({
  component: VisitPlanPanelsComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appVisitScheduleAgentsList', downgradeComponent({
  component: VisitScheduleAgentsListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appVisitPlanInfoTooltip', downgradeComponent({
  component: VisitPlanInfoTooltipComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);


ngApp.factory('visitPlanHttpService', lazyDowngradeInjectable(VisitPlanHttpService, downgradedAppModule));
ngApp.factory('visitPlanFacadeService', lazyDowngradeInjectable(VisitPlanFacadeService, downgradedAppModule));
ngApp.factory('visitPlanAccountFacadeService', lazyDowngradeInjectable(VisitPlanAccountFacadeService, downgradedAppModule));
ngApp.factory('visitConfigurationFacadeService', lazyDowngradeInjectable(VisitConfigurationFacadeService, downgradedAppModule));
ngApp.factory('visitConfigurationHttpService', lazyDowngradeInjectable(VisitConfigurationHttpService, downgradedAppModule));
ngApp.factory('visitPlanScheduleFacadeService', lazyDowngradeInjectable(VisitPlanScheduleFacadeService, downgradedAppModule));
ngApp.factory('visitScheduleFacadeService', lazyDowngradeInjectable(VisitScheduleFacadeService, downgradedAppModule));
ngApp.factory('visitScheduleRoutesChannelService', lazyDowngradeInjectable(VisitScheduleRoutesChannelService, downgradedAppModule));
ngApp.factory('expensesHttpService', lazyDowngradeInjectable(ExpensesHttpService, downgradedAppModule));
ngApp.factory('batchRecoveryHttpService', lazyDowngradeInjectable(BatchRecoveryHttpService, downgradedAppModule));
ngApp.factory('siteProvidersService', lazyDowngradeInjectable(SiteProvidersService, downgradedAppModule));


// Recommendation
ngApp.directive('appRecommendationWidget', downgradeComponent({
  component: RecommendationWidgetComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appRecommendationPanelLayout', downgradeComponent({
  component: RecommendationPanelLayoutComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appRecommendationGroupsPanelLayout', downgradeComponent({
  component: RecommendationGroupsPanelLayoutComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

// Metric Widget
ngApp.directive('appVisitPlanMetricWidget', downgradeComponent({
  component: VisitPlanMetricWidgetComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

//AI Agents
ngApp.factory('aiAgentsHttpService', lazyDowngradeInjectable(AiAgentsHttpService, downgradedAppModule));
ngApp.directive('appAiAgentsTable', downgradeComponent({
  component: AiAgentsTableComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.factory('accountsHttpService', lazyDowngradeInjectable(AccountsHttpService, downgradedAppModule));

// Site Settings - Providers
ngApp.directive('appSiteProvidersView', downgradeComponent({
  component: SiteProvidersViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appSettingsAuditLogView', downgradeComponent({
  component: SettingsAuditLogComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplTrainVouchersView', downgradeComponent({
  component: ThreeplTrainVouchersViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appVouchersPrintPage', downgradeComponent({
  component: VouchersPrintPageComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplServiceLink', downgradeComponent({
  component: ThreeplServiceLinkComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplCreateTrainVoucherView', downgradeComponent({
  component: ThreeplCreateTrainVoucherViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplServiceView', downgradeComponent({
  component: ThreeplServiceViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplServiceTimeline', downgradeComponent({
  component: ThreeplServiceTimelineComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplServiceMap', downgradeComponent({
  component: ThreeplServiceMapComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplProviderExtraDataView', downgradeComponent({
  component: ThreeplProviderExtraDataViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appThreeplServicesView', downgradeComponent({
  component: ThreeplServicesViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appAccountThreeplServices', downgradeComponent({
  component: AccountThreeplServicesComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appProviderTypeMultiSelectList', downgradeComponent({
  component: ProviderTypeMultiSelectListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.directive('appProviderTypesDisplayList', downgradeComponent({
  component: ProviderTypesDisplayListComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);

ngApp.factory('threePLTrainService', lazyDowngradeInjectable(ThreePLTrainService, downgradedAppModule));
ngApp.factory('threePLService', lazyDowngradeInjectable(ThreePLServiceActionsService, downgradedAppModule));

// Administration - Policy (terms versions)
ngApp.directive('appTermsView', downgradeComponent({
  component: TermsViewComponent,
  downgradedModule: downgradedAppModule
}) as angular.IDirectiveFactory);
